/*
 * BuroEcl
 * Copyright (c) 2023 Buroclic. All rights reserved.
 * 
 * This file corresponds to the Authentication error Page
 * The cabinet's alias should be missing in this URI
 * It will show a simple error message
 */

// Imports
import React, { useState } from 'react';

// Utils
import { useIsMobileScreen } from '../../utils/MobileScreenContext';

// Buroclic adaptive components
import { PoweredByBc } from '../../buroclic/PoweredByBc';

export const LoginErrorPage = (props) => {
  document.title = 'Votre espace client';

  const isMobileScreen = useIsMobileScreen();

  const [errorMessage] = useState(props.error);

  const renderMobile = () => {
    return (
      <div className={`justify-center flex flex-col rounded-sm m-4`} style={{ width: 'calc(100vw - 3rem)' }} >
        <img src={`/images/buroclic.png`} alt="Company logo" className={`h-full w-full object-contain object-center max-h-96 my-4 mx-auto max-w-[75%]`} />

        <div className="bg-[#f7f7f7] border border-black rounded-md mt-8 p-12 pb-0 px-3 pt-2 sm:h-4/5 lg:h-2/3 grow" style={{ width: '-webkit-fill-available' }}>
          <div className='flex flex-col h-full' style={{ height: 'calc(100% - 2rem)' }}>

            <div className='flex flex-col items-start grow'>
              <img src="/images/connexionIcon.png" alt="User icon" className="mx-auto mb-4 w-1/5" />

              <h5 className='self-center text-5xl font-bold mb-4'>Oups ...</h5>
              <p className="justify-center text-center mb-8 text-red-500 mx-auto text-4xl font-bold ">{errorMessage}</p>
            </div>
          <PoweredByBc className={'text-center py-1'} imgClassName={'h-full w-auto m-auto mb-16'} />
          </div>
        </div>

      </div>
    );
  }

  const renderComputer = () => {
    return (
      <div className="h-full flex items-center justify-center bg-cover bg-no-repeat" style={{ backgroundImage: `url('/images/background.png')` }}>
        <div className="w-4/5 justify-center flex flex-col bg-white rounded-lg lg:w-1/3 min-h-[40vh] h-[40vh] lg:mr-auto lg:ml-12 lg:h-[min-content] lg:my-auto">
          <img src={`/images/buroclic.png`} alt="Company logo" className={`h-auto w-full object-contain object-center max-h-[16rem] mt-4 mx-auto max-w-[16rem]`} />
          <div className="border border-black rounded-md p-12 sm:m-3 lg:m-12 pb-0 px-3 pt-2 sm:h-4/5 lg:h-2/3 grow bg-[#f7f7f7]" style={{ width: '-webkit-fill-available' }}>
            <div className='flex flex-col items-start grow mb-4' style={{ height: 'calc(100% - 2rem)' }}>
              <img src="/images/connexionIcon.png" alt="User icon" className="mx-auto mb-2 lg:w-1/5 w-10" />

              <h5 className='self-center mb-2'>Oups ...</h5>
              <p className="justify-center text-center text-red-500 mx-auto font-bold ">{errorMessage}</p>
            </div>
            <PoweredByBc className={'h-8 py-1 mx-auto'} imgClassName={'h-full w-auto m-auto mb-8'} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='h-full w-full'>
      {isMobileScreen ? renderMobile() : renderComputer()}
    </div>
  );
};